import type { ReactNode } from "react"

import {
  BREADCRUMB_TOOLTIP_CLASS_NAME,
  BreadcrumbPage,
  TruncatedText,
} from "@coval/ui"

/**
 * The breadcrumb's current page, which is the page's `h1`, with its text
 * truncated and revealed in a tooltip.
 *
 * The truncating text sits inside the heading and is the tooltip trigger and
 * tab stop. `TruncatedText asChild` over `BreadcrumbPage` would instead give the
 * heading itself `role="button"` once the text clips, and the page would lose
 * its `h1`.
 */
export const TruncatedBreadcrumbPage = ({
  children,
}: {
  children: ReactNode
}) => (
  <BreadcrumbPage className="min-w-0">
    <TruncatedText
      tooltipClassName={BREADCRUMB_TOOLTIP_CLASS_NAME}
      tabIndex={0}
    >
      {children}
    </TruncatedText>
  </BreadcrumbPage>
)
